// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"Fieldset_fieldset__BI_Zh","legendWrapper":"Fieldset_legendWrapper__pErrq"};